import './App.css';
import {Header} from './myComponents/Header';
import {MainSec} from './myComponents/MainSec';

function App() {
  return (
    <>
    <Header/>
    <MainSec/>
    </>
  );
}

export default App;
